import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';

const uploadFile = async (
  type: string,
  formData: FormData
): Promise<ApiResponse<string>> => {
  const typeUrl = () => {
    if (type === 'image') {
      return 'advance';
    }
    return 'acp';
  };
  const response = await axiosIns.post(
    `/carehome/${typeUrl()}/upload`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};

export default uploadFile;
